import { render } from "./SuggestionsList.vue?vue&type=template&id=39cf1fa2&scoped=true"
import script from "./SuggestionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionsList.vue?vue&type=script&setup=true&lang=js"

import "./SuggestionsList.vue?vue&type=style&index=0&id=39cf1fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cf1fa2"],['__file',"src/components/UI/SuggestionsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39cf1fa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39cf1fa2', __exports__)) {
    api.reload('39cf1fa2', __exports__)
  }
  
  module.hot.accept("./SuggestionsList.vue?vue&type=template&id=39cf1fa2&scoped=true", () => {
    api.rerender('39cf1fa2', render)
  })

}


export default __exports__